module.exports = {"formats":{"date":"YYYY/MM/DD","hour":"hh:mm"},"occupancy":{"title":"OCCUPANCY OVERVIEW","desks":"Desks","floors":"Floors","meetingRooms":"Meeting Rooms","restaurant":{"title":"Rise Caf�","attendance1":"< 5 mn","attendance2":"from 5 to 10 mn","attendance3":"> 10 mn"}}}


//////////////////
// WEBPACK FOOTER
// ./src/store/i18n/locales/en.json
// module id = 124
// module chunks = 0